import { render, staticRenderFns } from "./orgDetail.vue?vue&type=template&id=1e2b38a7&scoped=true"
import script from "./orgDetail.vue?vue&type=script&lang=js"
export * from "./orgDetail.vue?vue&type=script&lang=js"
import style0 from "./orgDetail.vue?vue&type=style&index=0&id=1e2b38a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b38a7",
  null
  
)

export default component.exports